import { thunk } from 'easy-peasy';
import { API } from '@aws-amplify/api';
import awsApiConfig from './config/awsApiConfigure';

API.configure(awsApiConfig);

const OrdersMiddleware = {
  //✨✨==========================================✨✨
  //            GET LIST PURCHASE ORDERS
  //  (non classés, triés par createdAt DESC)
  //✨✨==========================================✨✨
  getListOrders: thunk(
    async (actions, { limit = 25, nextToken } = {}, { getStoreActions }) => {
      const graphqlQuery = `
      query GetListOrders(
        $orderType: String!,
        $filter: ModelOrderCouponFilterInput,
        $limit: Int,
        $nextToken: String
      ) {
        orderCouponsByDate(
          orderType: $orderType,
          sortDirection: DESC,
          filter: $filter,
          limit: $limit,
          nextToken: $nextToken
        ) {
          items {
            id
            name
            numero
            createdAt
            ctm
            worksite {
              type {
                name
              }
              name
              company {
                name
              }
            }
            orderCouponCollaboratorId
            collaborator {
              first_name
              last_name
            }
          }
          nextToken
        }
      }
    `;

      const globalActions = getStoreActions().global;
      globalActions.setActivity(true);

      try {
        const res = await API.graphql({
          query: graphqlQuery,
          variables: {
            orderType: "ORDER",
            filter: {
              not: { classified: { eq: false } },
            },
            limit,
            nextToken,
          },
        });

        const data = res.data?.orderCouponsByDate || {};
        const items = data.items || [];
        const token = data.nextToken || null;

        console.log("DATA getListOrders", items);

        return { items, nextToken: token };
      } finally {
        globalActions.setActivity(false);
      }
    }
  ),


  //✨✨==========================================✨✨
  //       LIST ALL ORDERS COUPONS (PAGINATED)
  //     Triés par createdAt DESC via index
  //✨✨==========================================✨✨
  listAllOrdersCoupons: thunk(
    async (actions, { limit = 25, nextToken } = {}, { getStoreActions }) => {
      const graphqlQuery = `
      query ListOrderCouponsByDate(
        $orderType: String!,
        $limit: Int,
        $nextToken: String
      ) {
        orderCouponsByDate(
          orderType: $orderType,
          sortDirection: DESC,
          limit: $limit,
          nextToken: $nextToken
        ) {
          items {
            id
            revisionOfId
            name
            numero
            createdAt
            ctm
            nameWorksite
            nameClient
            worksite {
              type { name }
              name
              company { name }
            }
            orderCouponCollaboratorId
            collaborator {
              first_name
              last_name
            }
          }
          nextToken
        }
      }
    `;

      const globalActions = getStoreActions().global;
      globalActions.setActivity(true);

      try {
        const res = await API.graphql({
          query: graphqlQuery,
          variables: {
            orderType: "ORDER",
            limit,
            nextToken,
          },
        });

        const data = res.data?.orderCouponsByDate || {};
        return {
          items: data.items || [],
          nextToken: data.nextToken || null,
        };
      } finally {
        globalActions.setActivity(false);
      }
    }
  ),


  //✨✨==========================================✨✨
  //             DELETE ORDER COUPON
  //✨✨==========================================✨✨
  removeOrderCoupon: thunk(async (actions, id, { getStoreActions }) => {
    const graphqlMutation = `
    mutation DeleteOrderCoupon($input: DeleteOrderCouponInput!) {
      deleteOrderCoupon(input: $input) {
        id
      }
    }
  `;

    getStoreActions().global.setActivity(true);
    try {
      await API.graphql({
        query: graphqlMutation,
        variables: { input: { id } },
      });
      // tu peux faire un actions.removeLocalOrder(id) ici si tu as un state local
    } finally {
      getStoreActions().global.setActivity(false);
    }
  }),


  //✨✨==========================================✨✨
  //        GET LIST INTERVENTION ORDERS
  //  (non classés, triés par createdAt DESC)
  //✨✨==========================================✨✨
  getListInterventionOrders: thunk(
    async (actions, { limit = 25, nextToken } = {}, { getStoreActions }) => {
      const graphqlQuery = `
      query GetListInterventionOrders(
        $orderType: String!,
        $filter: ModelInterventionCouponFilterInput,
        $limit: Int,
        $nextToken: String
      ) {
        interventionsCouponsByDate(
          orderType: $orderType,
          sortDirection: DESC,
          filter: $filter,
          limit: $limit,
          nextToken: $nextToken
        ) {
          items {
            id
            name
            interventionCouponUserId
            startDate
            endDate
            extraTechnicians
            numero
            createdAt
            ctm
            worksite {
              type { name }
              name
              company { name }
            }
          }
          nextToken
        }
      }
    `;

      const globalActions = getStoreActions().global;
      globalActions.setActivity(true);

      try {
        const res = await API.graphql({
          query: graphqlQuery,
          variables: {
            orderType: "INTERVENTION",
            filter: {
              not: { classified: { eq: false } },
            },
            limit,
            nextToken,
          },
        });

        const data = res.data?.interventionsCouponsByDate || {};
        const items = data.items || [];
        const token = data.nextToken || null;

        console.log("DATA getListInterventionOrders", items);

        return { items, nextToken: token };
      } finally {
        globalActions.setActivity(false);
      }
    }
  ),


  //✨✨==========================================✨✨
  //    LIST ALL INTERVENTION COUPONS (PAGINATED)
  //   Triés par createdAt DESC via index
  //✨✨==========================================✨✨
  listAllInterventionCoupons: thunk(
    async (actions, { limit = 25, nextToken } = {}, { getStoreActions }) => {
      const graphqlQuery = `
      query ListInterventionCouponsByDate(
        $orderType: String!,
        $limit: Int,
        $nextToken: String
      ) {
        interventionsCouponsByDate(
          orderType: $orderType,
          sortDirection: DESC,
          limit: $limit,
          nextToken: $nextToken
        ) {
          items {
            id
            revisionOfId
            name
            interventionCouponUserId
            numero
            createdAt
            ctm
            nameWorksite
            startDate
            endDate
            extraTechnicians
            nameClient
            worksite {
              type { name }
              name
              company { name }
            }
          }
          nextToken
        }
      }
    `;

      const globalActions = getStoreActions().global;
      globalActions.setActivity(true);

      try {
        const res = await API.graphql({
          query: graphqlQuery,
          variables: {
            orderType: "INTERVENTION",
            limit,
            nextToken,
          },
        });

        const data = res.data?.interventionsCouponsByDate || {};
        return {
          items: data.items || [],
          nextToken: data.nextToken || null,
        };
      } finally {
        globalActions.setActivity(false);
      }
    }
  ),


  //✨✨==========================================✨✨
  //             DELETE INTERVENTION COUPON
  //✨✨==========================================✨✨
  removeInterventionCoupon: thunk(async (actions, id, { getStoreActions }) => {
    const graphqlMutation = `
    mutation DeleteInterventionCoupon($input: DeleteInterventionCouponInput!) {
      deleteInterventionCoupon(input: $input) {
        id
      }
    }
  `;
    getStoreActions().global.setActivity(true);
    try {
      await API.graphql({
        query: graphqlMutation,
        variables: { input: { id } },
      });
      // tu peux faire un actions.removeLocalOrder(id) ici si tu as un state local

    } finally {
      getStoreActions().global.setActivity(false);
    }
  }),


  //✨✨==========================================✨✨
  //      GET LIST INTERVENTION CTM ORDERS
  // (CouponPreInter signés, triés par createdAt DESC)
  //✨✨==========================================✨✨
  getListInterventionCtmOrders: thunk(
    async (actions, { limit = 25, nextToken } = {}, { getStoreActions }) => {
      const graphqlQuery = `
      query GetListInterventionCtmOrders(
        $orderType: String!,
        $filter: ModelCouponPreInterFilterInput,
        $limit: Int,
        $nextToken: String
      ) {
        couponPreIntersByDate(
          orderType: $orderType,
          sortDirection: DESC,
          filter: $filter,
          limit: $limit,
          nextToken: $nextToken
        ) {
          items {
            id
            numero
            dateSigned
            worksites {
              name
              type { name }
              company { name }
            }
          }
          nextToken
        }
      }
    `;

      const globalActions = getStoreActions().global;
      globalActions.setActivity(true);

      try {
        const res = await API.graphql({
          query: graphqlQuery,
          variables: {
            orderType: "PRE_INTERVENTION",
            filter: {
              dateSigned: { attributeExists: true },
            },
            limit,
            nextToken,
          },
        });

        const data = res.data?.couponPreIntersByDate || {};
        const items = data.items || [];
        const token = data.nextToken || null;

        console.log("DATA getListInterventionCtmOrders", items);

        return { items, nextToken: token };
      } finally {
        globalActions.setActivity(false);
      }
    }
  ),


  //✨✨==========================================✨✨
  //      LIST ALL PREFILL COUPONS (PAGINATED)
  //   Triés par createdAt DESC via index
  //✨✨==========================================✨✨
  listAllPrefillCoupons: thunk(
    async (actions, { limit = 25, nextToken } = {}, { getStoreActions }) => {
      const graphqlQuery = `
      query ListPrefillCouponsByDate(
        $orderType: String!,
        $limit: Int,
        $nextToken: String
      ) {
        couponPreIntersByDate(
          orderType: $orderType,
          sortDirection: DESC,
          limit: $limit,
          nextToken: $nextToken
        ) {
          items {
            id
            numero
            dateSigned
            worksites {
              name
              type { name }
              company { name }
            }
          }
          nextToken
        }
      }
    `;

      const globalActions = getStoreActions().global;
      globalActions.setActivity(true);

      try {
        const res = await API.graphql({
          query: graphqlQuery,
          variables: {
            orderType: "PRE_INTERVENTION",
            limit,
            nextToken,
          },
        });

        const data = res.data?.couponPreIntersByDate || {};
        return {
          items: data.items || [],
          nextToken: data.nextToken || null,
        };
      } finally {
        globalActions.setActivity(false);
      }
    }
  ),


  //✨✨==========================================✨✨
  //             DELETE PREFILL COUPON
  // ✨✨==========================================✨✨
  removePrefillCoupon: thunk(async (actions, id, { getStoreActions }) => {
    const graphqlMutation = `
    mutation DeleteCouponPreInter($input: DeleteCouponPreInterInput!) {
      deleteCouponPreInter(input: $input) {
        id
      }
    }
  `;
    getStoreActions().global.setActivity(true);
    try {
      await API.graphql({
        query: graphqlMutation,
        variables: { input: { id } },
      });
      // tu peux faire un actions.removeLocalOrder(id) ici si tu as un state local
    } finally {
      getStoreActions().global.setActivity(false);
    }
  }),


  //✨✨==========================================✨✨
  //            GET ORDER COUPON
  //✨✨==========================================✨✨
  getOrderCoupon: thunk(async (actions, payload, { getStoreActions, getStoreState }) => {
    // body request
    const graphqlQuery = `
    query MyQuery {
      getOrderCoupon(id: "${payload}") {
        id
        numero
        name
        signed
        nameClient
        nameWorksite
        createdAt
        updatedAt
        worksite {
          company {
            address
            mail
            siret
            name
          }
          name
        }
        materialData {
          items {
            name
            quantity
            quantityLabel
            materialSettings {
              name
              references {
                published
                reference
              }
            }
            indexRef
            description
          }
        }
        company {
          address
          mail
          name
          siret
        }
        collaborator {
          first_name
          last_name              
        }
      }
    }`;
    getStoreActions().global.setActivity(true);
    try {
      const query = await API.graphql({
        query: graphqlQuery,
      });
      const myData = query.data?.getOrderCoupon;
      return myData;
    } finally {
      getStoreActions().global.setActivity(false);
    }
  }),


  //✨✨==========================================✨✨
  //            GET ORDER COUPON BY ID
  //✨✨==========================================✨✨
  getOrderCouponById: thunk(async (actions, payload, { getStoreActions, getStoreState }) => {
    // body request
    const graphqlQuery = `
    query MyQuery {
      getOrderCoupon(id: "${payload}") {
        classified
        name
        numero
        signed
        worksite {
          id
          company {
            name
          }
        }
        materialData {
          items {
            id
            indexRef
            quantity
            quantityLabel
            materialSettings {
              id
              name
              references {
                published
                reference
              }
            }
          }
        }
      }
    }`;
    getStoreActions().global.setActivity(true);
    try {
      const query = await API.graphql({
        query: graphqlQuery,
      });
      const myData = query.data?.getOrderCoupon;
      return myData;
    } finally {
      getStoreActions().global.setActivity(false);
    }
  }),


  //✨✨==========================================✨✨
  //            GET INTERVENTION COUPON
  //✨✨==========================================✨✨
  getInterventionCoupon: thunk(async (actions, payload, { getStoreActions, getStoreState }) => {
    // body request
    const graphqlQuery = `
    query MyQuery {
      getInterventionCoupon(id: "${payload}") {
        id
        ctm
        numero
        name
        interventionCouponUserId
        bcCtm
        nameWorksite
        nameClient
        newMailClient
        startDate
        endDate
        extraTechnicians
        createdAt
        updatedAt
        worksite {
          company {
            name
            siret
            address
            mail
            phone
          }
          name
          date_planned
        }
        materialData {
          items {
            name
            materialSettings {
              references {
                published
                reference
              }
              name
            }
            surface
            quantity
            quantityLabel
            indexRef
            description
            referenceQr
            address
            poseAddress
            typeInterventionSettings {
              name
            }
          }
        }
        signed
        orderCoupon {
          numero
        }
      }
    }`;
    getStoreActions().global.setActivity(true);
    try {
      const query = await API.graphql({
        query: graphqlQuery,
      });
      const myData = query.data?.getInterventionCoupon;
      return myData;
    } finally {
      getStoreActions().global.setActivity(false);
    }
  }),


  //✨✨==========================================✨✨
  //            GET LIST INTERVENTION SETTINGS
  //✨✨==========================================✨✨
  getListInterventionSettings: thunk(async (actions, payload, { getStoreActions, getStoreState }) => {
    // body request
    const graphqlQuery = `
    query MyQuery {
      listTypeInterventionSettings {
        items {
          id
          name
        }
      }
    }`;
    getStoreActions().global.setActivity(true);
    try {
      const query = await API.graphql({
        query: graphqlQuery,
      });
      const myData = query.data?.listTypeInterventionSettings.items;
      return myData;
    } finally {
      getStoreActions().global.setActivity(false);
    }
  }),


  //✨✨==========================================✨✨
  //            GET LIST MATERIAL SETTINGS
  //✨✨==========================================✨✨
  getListMaterialSettings: thunk(async (actions, payload, { getStoreActions, getStoreState }) => {
    // body request
    const graphqlQuery = `
    query MyQuery {
      listMaterialSettings {
        items {
          name
          id
          references {
            published
            reference
          }
        }
      }
    }`;
    getStoreActions().global.setActivity(true);
    try {
      const query = await API.graphql({
        query: graphqlQuery,
      });
      const myData = query.data?.listMaterialSettings.items;
      return myData;
    } finally {
      getStoreActions().global.setActivity(false);
    }
  }),


  // ✨✨==========================================✨✨
  //            GET LIST ORDER COUPON (PAGINATED + TRI DATE)
  // ✨✨==========================================✨✨
  getListOrderCoupon: thunk(
    async (
      actions,
      { limit = 25, nextToken } = {},
      { getStoreActions }
    ) => {
      const graphqlQuery = `
      query OrderCouponsByDate(
        $orderType: String!
        $sortDirection: ModelSortDirection
        $filter: ModelOrderCouponFilterInput
        $limit: Int
        $nextToken: String
      ) {
        orderCouponsByDate(
          orderType: $orderType
          sortDirection: $sortDirection
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          items {
            classified
            id
            name
            nameClient
            nameWorksite
            numero
            orderCouponCollaboratorId
            signed
            updatedAt
            createdAt
            collaborator {
              first_name
              last_name
              type {
                name
              }
            }
          }
          nextToken
        }
      }
    `;

      const variables = {
        orderType: "ORDER",                    // 🔹 tu peux ajuster si besoin
        sortDirection: "DESC",                 // 🔹 plus récent en premier
        filter: { classified: { eq: false } }, // 🔹 seulement non classés
        limit,
        nextToken,
      };

      const global = getStoreActions().global;
      global.setActivity(true);

      try {
        const res = await API.graphql({
          query: graphqlQuery,
          variables,
        });

        const data = res.data?.orderCouponsByDate || {};
        return {
          items: data.items || [],
          nextToken: data.nextToken || null,
        };
      } finally {
        global.setActivity(false);
      }
    }
  ),

  // ✨✨==========================================✨✨
  //         GET LIST INTERVENTION COUPON (PAGINATED + TRI DATE)
  // ✨✨==========================================✨✨
  getListInterventionCoupon: thunk(
    async (
      actions,
      { limit = 25, nextToken } = {},
      { getStoreActions }
    ) => {
      const graphqlQuery = `
      query InterventionsCouponsByDate(
        $orderType: String!
        $sortDirection: ModelSortDirection
        $filter: ModelInterventionCouponFilterInput
        $limit: Int
        $nextToken: String
      ) {
        interventionsCouponsByDate(
          orderType: $orderType
          sortDirection: $sortDirection
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          items {
            createdAt
            classified
            id
            ctm
            bcCtm
            interventionCouponOrderCouponId
            interventionCouponUserId
            nameClient
            name
            nameWorksite
            startDate
            endDate
            extraTechnicians
            numero
            orderCoupon {
              collaborator {
                type {
                  name
                }
              }
            }
          }
          nextToken
        }
      }
    `;

      const variables = {
        orderType: "INTERVENTION",             // 🔹 cohérent avec ton schéma
        sortDirection: "DESC",
        filter: { classified: { eq: false } },
        limit,
        nextToken,
      };

      const global = getStoreActions().global;
      global.setActivity(true);

      try {
        const res = await API.graphql({
          query: graphqlQuery,
          variables,
        });

        const data = res.data?.interventionsCouponsByDate || {};
        return {
          items: data.items || [],
          nextToken: data.nextToken || null,
        };
      } finally {
        global.setActivity(false);
      }
    }
  ),


  //✨✨==========================================✨✨
  //         GET LIST WORKSITES CLASSIFY
  //✨✨==========================================✨✨
  getListWorksitesClassify: thunk(async (actions, payload, { getStoreActions, getStoreState }) => {
    // body request
    const graphqlQuery = `
      query MyQuery {
        listWorksites(limit: 500000) {
          items {
            id
            name
          }
        }
      }`;
    getStoreActions().global.setActivity(true);
    try {
      const query = await API.graphql({
        query: graphqlQuery,
      });
      const myData = query.data?.listWorksites.items;
      return myData;
    } finally {
      getStoreActions().global.setActivity(false);
    }
  }),


  //✨✨==========================================✨✨
  //         GET LIST COMPANY CLASSIFY
  //✨✨==========================================✨✨
  getListCompanyClassify: thunk(async (actions, payload, { getStoreActions, getStoreState }) => {
    // body request
    const graphqlQuery = `
      query MyQuery {
        listTypeCompanies(filter: {name: {eq: "client"}}) {
          items {
            id
            name
            companies {
              items {
                id
                name
                worksites {
                  items {
                    id
                    name
                  }
                }
              }
            }
          }
        }
      }`;
    getStoreActions().global.setActivity(true);
    try {
      const query = await API.graphql({
        query: graphqlQuery,
      });
      const myData = query.data?.listTypeCompanies.items;
      return myData;
    } finally {
      getStoreActions().global.setActivity(false);
    }
  }),


  //✨✨==========================================✨✨
  //           CREATE MATERIAL DATA
  //✨✨==========================================✨✨
  createMaterialData: thunk(async (actions, payload, { getStoreActions, getStoreState }) => {
    // body request
    const graphqlQuery = `
    mutation MyMutation {
      createMaterialData(input: {
        name: "${payload.name}",
        quantity: ${payload.quantity},
        ${payload.quantityLabel ? `,quantityLabel: "${payload.quantityLabel}"` : ''}  
        ${payload.address ? `,address: "${payload.address}"` : ''}
        ${payload.poseAddress ? `,poseAddress: "${payload.poseAddress}"` : ''}
        ${payload.indexRef !== undefined ? `,indexRef: ${payload.indexRef}` : ''}
        ${payload.description ? `,description: "${payload.description}"` : ''}
        ${payload.referenceQr ? `,referenceQr: "${payload.referenceQr}"` : ''}
        ${payload.orderCouponId ? `,orderCouponMaterialDataId: "${payload.orderCouponId}"` : ''}
        ${payload.materialSettingsId ? `,materialDataMaterialSettingsId: "${payload.materialSettingsId}"` : ''}
        ${payload.typeInterventionSettingsId
        ? `,materialDataTypeInterventionSettingsId: "${payload.typeInterventionSettingsId}"`
        : ''
      }
        ${payload.interventionCouponId ? `,interventionCouponMaterialDataId: "${payload.interventionCouponId}"` : ''}
      })
      {
        id
      }
    }`;
    getStoreActions().global.setActivity(true);
    try {
      const query = await API.graphql({
        query: graphqlQuery,
      });
      const myData = query.data?.createMaterialData;
      return myData;
    } finally {
      getStoreActions().global.setActivity(false);
    }
  }),


  //✨✨==========================================✨✨
  //           CREATE INTERVENTION COUPON
  //✨✨==========================================✨✨
  createInterventionCoupon: thunk(async (actions, payload, { getStoreActions, getStoreState }) => {
    // body request
    const graphqlQuery = `
    mutation MyMutation {
      createInterventionCoupon(input: {
        orderType: "INTERVENTION",
        bcCtm: "${payload.bcCtm}",
        ctm: "true", 
        interventionCouponUserId: "${payload.colabSelected}",
        name: "Vétilla Zobda", 
        numero: "${payload.numero}", 
        worksiteIntervention_couponId: "${payload.worksite}"
      }) 
      {
        id
      }
    }`;
    getStoreActions().global.setActivity(true);
    try {
      const query = await API.graphql({
        query: graphqlQuery,
      });
      const myData = query.data?.createInterventionCoupon;
      payload.listeMaterialCreate.forEach((material) => {
        const newDate = {
          ...material,
          interventionCouponId: query.data?.createInterventionCoupon,
          materialSettingsId: material.idMaterial,
          indexRef: material.reference,
          typeInterventionSettingsId: material.typeInterventionSettingsId,
        };
        OrdersMiddleware.createMaterialData(newDate);
      });
      return myData;
    } finally {
      getStoreActions().global.setActivity(false);
    }
  }),


  //✨✨==========================================✨✨
  //            CREATE ORDER COUPON
  //✨✨==========================================✨✨
  createOrderCoupon: thunk(async (actions, payload, { getStoreActions, getStoreState }) => {
    // body request
    const graphqlQuery = `
    mutation MyMutation {
      createOrderCoupon(input: {
        orderType: "ORDER",
        name: "${payload.name}",
        orderCouponCompanyId: "${payload.idSaca}", 
        numero: "${payload.numero}", 
        worksiteOrder_couponId: "${payload.worksiteId}", 
        bcCtm: "", 
        ctm: "true"
        }) {
        id
      }
    }`;
    getStoreActions().global.setActivity(true);
    try {
      const query = await API.graphql({
        query: graphqlQuery,
      });
      const myData = query.data?.createOrderCoupon;
      payload.listeMaterialCreate.forEach((material) => {
        const newData = {
          ...material,
          orderCouponId: query.data?.createOrderCoupon.id,
          materialSettingsId: material.idMaterial,
          indexRef: material.reference,
        };
        actions.createMaterialData(newData);
      });
      return myData;
    } finally {
      getStoreActions().global.setActivity(false);
    }
  }),


  //✨✨==========================================✨✨
  //            UPDATE ORDER COUPON
  //✨✨==========================================✨✨
  updateOrderCoupon: thunk(async (actions, payload, { getStoreActions, getStoreState }) => {
    // body request
    const graphqlQuery = `
    mutation MyMutation {
      updateOrderCoupon(input: {
        id: "${payload.id}", 
        numero: "${payload.numero}", 
        name: "${payload.name}", 
        ctm: "true", 
        bcCtm: "", 
        orderCouponCompanyId: "${payload.idSaca}", 
        worksiteOrder_couponId: "${payload.worksiteId}"
        }) {
        id
      }
    }`;
    getStoreActions().global.setActivity(true);
    try {
      const query = await API.graphql({
        query: graphqlQuery,
      });
      const myData = query.data?.updateOrderCoupon;
      if (payload.newListeMaterialCreate.length >= 1) {
        payload.newListeMaterialCreate.forEach((material) => {
          const newDate = {
            ...material,
            orderCouponId: query.data?.updateOrderCoupon.id,
            materialSettingsId: material.idMaterial,
            indexRef: material.reference,
          };
          actions.createMaterialData(newDate);
        });
      }
      payload.listeMaterialCreate.forEach((material) => {
        const newDate = {
          ...material,
          orderCouponId: query.data?.updateOrderCoupon.id,
          materialSettingsId: material.idMaterial,
          indexRef: material.reference,
        };
        actions.updateMaterialData(newDate);
      });
      return myData;
    } finally {
      getStoreActions().global.setActivity(false);
    }
  }),


  //✨✨==========================================✨✨
  //            UPDATE INTERVENTION COUPON
  //✨✨==========================================✨✨
  updateInterventionCoupon: thunk(async (actions, payload, { getStoreActions, getStoreState }) => {
    // body request
    const graphqlQuery = `
    mutation MyMutation {
        updateInterventionCoupon(input: {
          id: "${payload.id}"
          bcCtm: "${payload.bcCtm}",
          ctm: "true", 
          interventionCouponUserId: "${payload.colabSelected}",
          name: "Vétilla Zobda", 
          numero: "${payload.numero}", 
          worksiteIntervention_couponId: "${payload.worksite}"
        }) 
        {
          id
        }
      }`;
    getStoreActions().global.setActivity(true);
    try {
      const query = await API.graphql({
        query: graphqlQuery,
      });
      const myData = query.data?.updateInterventionCoupon;
      if (payload.newListeMaterialCreate.length >= 1) {
        payload.newListeMaterialCreate.forEach((material) => {
          const newDate = {
            ...material,
            interventionCouponId: query.data?.updateInterventionCoupon.id,
            materialSettingsId: material.idMaterial,
            indexRef: material.reference,
            typeInterventionSettingsId: material.typeInterventionSettingsId,
          };
          actions.createMaterialData(newDate);
        });
      }
      payload.listeMaterialCreate.forEach((material) => {
        const newDate = {
          ...material,
          interventionCouponId: query.data?.updateInterventionCoupon.id,
          materialSettingsId: material.idMaterial,
          indexRef: material.reference,
        };
        actions.updateMaterialData(newDate);
      });
      return myData;
    } finally {
      getStoreActions().global.setActivity(false);
    }
  }),


  //✨✨==========================================✨✨
  //            UPDATE MATERIAL DATA
  //✨✨==========================================✨✨
  updateMaterialData: thunk(async (actions, payload, { getStoreActions, getStoreState }) => {
    // body request
    const graphqlQuery = `
    mutation MyMutation {
      updateMaterialData(input: {
        id :  "${payload.id}",
        name: "${payload.name}",
        quantity: ${payload.quantity},
        ${payload.quantityLabel ? `,quantityLabel: "${payload.quantityLabel}"` : ''}
        ${payload.address ? `,address: "${payload.address}"` : ''}
        ${payload.indexRef !== undefined ? `,indexRef: ${payload.indexRef}` : ''}
        ${payload.description ? `,description: "${payload.description}"` : ''}
        ${payload.referenceQr ? `,referenceQr: "${payload.referenceQr}"` : ''}
        ${payload.orderCouponId ? `,orderCouponMaterialDataId: "${payload.orderCouponId}"` : ''}
        ${payload.materialSettingsId ? `,materialDataMaterialSettingsId: "${payload.materialSettingsId}"` : ''}
        ${payload.typeInterventionSettingsId
        ? `,materialDataTypeInterventionSettingsId: "${payload.typeInterventionSettingsId}"`
        : ''
      }
        ${payload.interventionCouponId ? `,interventionCouponMaterialDataId: "${payload.interventionCouponId}"` : ''}
      })
      {
        id
      }
    }`;
    getStoreActions().global.setActivity(true);
    try {
      const query = await API.graphql({
        query: graphqlQuery,
      });
      const myData = query.data?.updateMaterialData;
      return myData;
    } finally {
      getStoreActions().global.setActivity(false);
    }
  }),


  //✨✨==========================================✨✨
  //            MOVE ORDER COUPON TO WORKSITE
  //✨✨==========================================✨✨
  moveOrderCouponToWorksite: thunk(async (actions, payload, { getStoreActions, getStoreState }) => {
    // body request
    const graphqlQuery = `
      mutation MyMutation {
        updateOrderCoupon(input: 
          {
            id: "${payload.id}", 
            worksiteOrder_couponId: "${payload.idWorksite}", 
            classified: ${true}}) 
          {
            id
          }
        }`;
    getStoreActions().global.setActivity(true);
    try {
      const query = await API.graphql({
        query: graphqlQuery,
      });
      const myData = query.data?.updateOrderCoupon;
      return myData;
    } finally {
      getStoreActions().global.setActivity(false);
    }
  }),


  //✨✨==========================================✨✨
  //            MOVE INTERVENTION COUPON TO WORKSITE
  //✨✨==========================================✨✨
  moveInterventionCouponToWorksite: thunk(async (actions, payload, { getStoreActions, getStoreState }) => {
    // body request
    const graphqlQuery = `
      mutation MyMutation {
        updateInterventionCoupon(input: 
          {
            id: "${payload.id}", 
            worksiteIntervention_couponId: "${payload.idWorksite}", 
            classified: true}) 
            {
            id
          }
        }`;
    getStoreActions().global.setActivity(true);
    try {
      const query = await API.graphql({
        query: graphqlQuery,
      });
      const myData = query.data?.updateInterventionCoupon;
      return myData;
    } finally {
      getStoreActions().global.setActivity(false);
    }
  }),


  //✨✨==========================================✨✨
  //          DELETE MATERIAL DATA
  //✨✨==========================================✨✨
  deleteMaterialData: thunk(async (actions, payload, { getStoreActions, getStoreState }) => {
    // body request
    const graphqlQuery = `
    mutation MyMutation {
      deleteMaterialData(input: {
      id: "${payload.id}"
      }) {
        id
      }
    }
    `;
    getStoreActions().global.setActivity(true);
    try {
      const query = await API.graphql({
        query: graphqlQuery,
      });
      const myData = query.data?.deleteMaterialData;
      return myData;
    } finally {
      getStoreActions().global.setActivity(false);
    }
  }),


  //✨✨==========================================✨✨
  //          DELETE MULTIPLE MATERIALS DATA
  //✨✨==========================================✨✨
  deletesMultipleMaterialsData: thunk(async (actions, payload, { getStoreActions, getStoreState }) => {
    // body request
    const graphqlQuery = `
    mutation MyMutation {
      ${payload.listMaterial.map(
      (material, index) =>
        `task${index}: deleteMaterialData(input: {id: "${material.id}"}) {
          id
        }`
    )}
    }
    `;
    getStoreActions().global.setActivity(true);
    try {
      const query = await API.graphql({
        query: graphqlQuery,
      });
      const myData = query.data?.deleteMaterialData;
      return myData;
    } finally {
      getStoreActions().global.setActivity(false);
    }
  }),


  //✨✨==========================================✨✨
  //          DELETE PREFILL COUPON
  //✨✨==========================================✨✨
  deletePrefillCoupon: thunk(async (actions, payload, { getStoreActions, getStoreState }) => {
    console.log("je rentre ici");

    // body request
    const graphqlQuery = `
    mutation MyMutation {
      deleteOrderCoupon(input: {
        id: "${payload.id}"
      }) 
      {
      id
        }
      }
    `;
    getStoreActions().global.setActivity(true);
    try {
      const query = await API.graphql({
        query: graphqlQuery,
      });
      const myData = query.data?.deleteOrderCoupon;
      return myData;
    } finally {
      getStoreActions().global.setActivity(false);
    }
  }),


  //✨✨==========================================✨✨
  //          DELETE INTERVENTION COUPON
  //✨✨==========================================✨✨
  deletePrefillInterventionCoupon: thunk(async (actions, payload, { getStoreActions, getStoreState }) => {
    // body request
    const graphqlQuery = `
    mutation MyMutation {
      deleteInterventionCoupon(input: {id: "${payload.id}"}, condition: {ctm: {eq: "true"}}) {
        id
      }
    }
    `;
    getStoreActions().global.setActivity(true);
    try {
      const query = await API.graphql({
        query: graphqlQuery,
      });
      const myData = query.data?.deleteInterventionCoupon;
      return myData;
    } finally {
      getStoreActions().global.setActivity(false);
    }
  }),


  //✨✨==========================================✨✨
  //            DELETE ORDER COUPON
  //✨✨==========================================✨✨
  deleteOrderCoupon: thunk(async (actions, payload, { getStoreActions, getStoreState }) => {
    // body request
    const graphqlQuery = `
      mutation MyMutation {
        deleteOrderCoupon(input: {id: "${payload}"}, condition: {classified: {eq: false}}) {
          id
        } 
      }`;
    getStoreActions().global.setActivity(true);
    try {
      const query = await API.graphql({
        query: graphqlQuery,
      });
      const myData = query.data?.deleteOrderCoupon;
      return myData;
    } finally {
      getStoreActions().global.setActivity(false);
    }
  }),


  //✨✨==========================================✨✨
  //            DELETE INTERVENTION COUPON
  //✨✨==========================================✨✨
  deleteInterventionCoupon: thunk(async (actions, payload, { getStoreActions, getStoreState }) => {
    // body request
    const graphqlQuery = `
      mutation MyMutation {
        deleteInterventionCoupon(input: {id: "${payload}"}, condition: {classified: {eq: false}}) {
          id
        } 
      }`;
    getStoreActions().global.setActivity(true);
    try {
      const query = await API.graphql({
        query: graphqlQuery,
      });
      const myData = query.data?.deleteInterventionCoupon;
      return myData;
    } finally {
      getStoreActions().global.setActivity(false);
    }
  }),


  //✨✨==========================================✨✨
  //            GET COMPANY
  //✨✨==========================================✨✨
  getCompany: thunk(async (actions, payload, { getStoreActions, getStoreState }) => {
    // body request
    const graphqlQuery = `
    query MyQuery {
      getCompany(id: "${payload}") {
        name
        worksites {
          items {
            id
            users {
              items {
                user {
                  first_name
                  last_name
                  id
                }
              }
            }
          }
        }
      }
    }`;
    getStoreActions().global.setActivity(true);
    try {
      const query = await API.graphql({
        query: graphqlQuery,
      });
      const myData = query.data?.getCompany;
      return myData;
    } finally {
      getStoreActions().global.setActivity(false);
    }
  }),


  // ✨✨==========================================✨✨
  //   INTERVENTION DOCUMENT BY INTERVENTION ID
  // ✨✨==========================================✨✨
  interventionDocumentsByIntervention: thunk(
    async (
      actions,
      { interventionCouponId, limit = 25, nextToken } = {},
      { getStoreActions }
    ) => {
      const graphqlQuery = `
      query InterventionDocumentsByIntervention(
        $interventionCouponId: ID!
        $sortDirection: ModelSortDirection
        $limit: Int
        $nextToken: String
      ) {
        interventionDocumentsByIntervention(
          interventionCouponId: $interventionCouponId
          sortDirection: $sortDirection
          limit: $limit
          nextToken: $nextToken
        ) {
          items {
            after
            before
            comment
            createdAt
            id
            interventionCouponId
            key
            updatedAt
          }
          nextToken
        }
      }
    `;

      const globalActions = getStoreActions().global;
      globalActions.setActivity(true);

      try {
        const res = await API.graphql({
          query: graphqlQuery,
          variables: {
            interventionCouponId,
            sortDirection: 'DESC',
            limit,
            nextToken,
          },
        });

        // 🔹 Correction ici
        const data = res.data?.interventionDocumentsByIntervention || {};
        return {
          items: data.items || [],
          nextToken: data.nextToken || null,
        };
      } finally {
        globalActions.setActivity(false);
      }
    }
  ),

};

export default OrdersMiddleware;

